import anime from 'animejs';

const transitionDelay = 500

export const shouldUpdateScroll = () => false

export const onRouteUpdate = () => window.setTimeout(() => { 

  window.scrollY > 250 && window.scrollTo(0, 250);

  anime({
    targets: 'html, body',
    scrollTop: 0,
    duration: 500,
    easing: 'easeOutCubic'
  });

  // document.querySelectorAll('html, body').forEach( (item) => {
  //   item.style.scrollBehavior = 'smooth'
  // })

  // window.setTimeout( () => {
  //   window.requestAnimationFrame( () => {
  //     window.scrollTo(0, 0);
  //   })
  // }, 500 )
}, transitionDelay)